import CloseIcon from '../../assets/icons/close.svg?react';

export interface FilterTag {
  /** Unique identifier for the tag */
  key: string;
  /** Display label for the tag */
  label: string;
  /** Callback when the tag is removed */
  onRemove: () => void;
}

interface ActiveFilterTagsProps {
  /** Array of active filter tags to display */
  tags: FilterTag[];
  /** Callback to clear all filters */
  onClearAll: () => void;
}

/**
 * Displays active filter tags with remove buttons and a "Clear all" button.
 * Similar styling to the MachineBadge component used in AddAlarmDialog.
 */
export function ActiveFilterTags({ tags, onClearAll }: ActiveFilterTagsProps) {
  if (tags.length === 0) return null;

  return (
    <div className='flex flex-wrap items-center gap-1.5'>
      {tags.map((tag) => (
        <div
          key={tag.key}
          className='bg-surface-focus-support border-border-primary size-caption
            text-primary flex items-center gap-1.5 rounded border px-2 py-1
            select-none'
        >
          <span>{tag.label}</span>
          <button
            type='button'
            onClick={tag.onRemove}
            className='text-secondary hover:text-primary -mr-0.5 flex
              cursor-pointer items-center justify-center'
            aria-label={`Remove filter: ${tag.label}`}
          >
            <CloseIcon className='h-2.5 w-2.5' />
          </button>
        </div>
      ))}
      <button
        type='button'
        onClick={onClearAll}
        className='size-caption text-focus hover:text-focus-hover cursor-pointer
          px-1 py-0.5'
      >
        Clear all
      </button>
    </div>
  );
}
